module.exports = __WEBPACK_EXTERNAL_MODULE__tableau_browser_support__;